module.exports = __webpack_public_path__ + "assets/7fc8bc311242aca7a7f69aaff9ba31b8.mp3";